class PaystubController {

  /* @ngInject */
  constructor (paystub, checkrData, user, inModal, $mdToast, $mdDialog, $mdMenu) {
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog
    this.$mdMenu = $mdMenu
    this.checkrData = checkrData
    this.paystub = paystub
    this.inModal = inModal
    if (!this.paystub.paystubType) {
      let d = new Date(this.paystub.pay_period_end.replace(/-/g, '/'))
      this.payEnd = ((d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear())
      d.setDate(d.getDate() - 6)
      this.payStart = ((d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear())
      this.deduct = JSON.parse(this.paystub.deduct)
      this.taxes = JSON.parse(this.paystub.taxes)
      this.pay_rates = JSON.parse(this.paystub.pay_rates)
    }
    this.user = user
  }

  close () {
    this.$mdDialog.cancel()
  }

  // addNote() {

  //   if (!this.message) {
  //     return
  //   }

  //   this.UsersService.addNote(this.user.id, this.message)
  //   this.$mdToast.showSimple('Note added')
  //   this.$mdDialog.cancel()
  // }
}

export default PaystubController

